<template>
  <a-modal
    :visible.sync="isVisible"
    :confirmLoading="loading"
    :maskClosable="false"
    :title="title"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="公司名称" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入"
          v-decorator="['name', {
            rules: [{ required: true, message: '名称不能为空' },
                    { pattern: /^[\u4E00-\u9FA5\uF900-\uFA2Da-zA-Z0-9]{2,40}$/, message: '输入字符必须是长度2~40的中英文和数字' }],
            validateTrigger: 'blur'
          }]"/>
      </a-form-item>
      <a-form-item label="公司电话" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input
          placeholder="请输入"
          v-decorator="['mobile', {
            rules: [{ required: true, max: 11, message: '最长不超过11个字符' }]
          }]"/>
      </a-form-item>
      <a-form-item label="公司地址" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-cascader
          placeholder="请选择省/市/区"
          :options="areaOptions"
          v-decorator="['province', {
            rules: [{ required: true, message: '请选择地址' }]
          }]"
          change-on-select
        />
      </a-form-item>
      <!-- 显示顺序输入项：限制输入范围1-999，默认值为50 -->
      <a-form-item label=" " :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }" :colon="false" >
        <a-input
          placeholder="请输入详细地址"
          v-decorator="['address', {
            rules: [{ required: false, message: '请输入详细地址' }]
          }]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createCompany, updateCompany } from '@/api/company'
import { areaOptions } from '@/utils/area'

export default {
  props: {
    visible: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      title: '新增公司',
      uuid: '',
      areaOptions: areaOptions,
      currentCompany: null
    }
  },

  computed: {
    isVisible: {
      get: function () {
        return this.visible
      },
      set: function (val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    load (company) {
      this.form.resetFields()
      if (company && company.id) {
        this.title = '编辑公司'
        this.currentCompany = company
        this.$nextTick(() => {
          this.form.setFieldsValue({
            name: company.name,
            mobile: company.mobile,
            province: company.province.split('/'),
            address: company.address
          })
        })
      }
    },

    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          const hotel = JSON.parse(JSON.stringify(values))
          if (this.currentCompany && this.currentCompany.id) {
            hotel.id = this.currentCompany.id
            hotel.province = hotel.province.join('/')
            updateCompany(hotel).then(response => {
              this.$message.success(response.msg)
              this.$emit('ok', hotel)
              this.handleCancel()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          } else {
            console.log(values)
            values.province = values.province.join('/')
            createCompany(values).then(response => {
              this.$message.success(response.msg)
              this.$emit('ok', response.data)
              this.handleCancel()
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          }
        } else {
          this.loading = false
        }
      })
    },

    handleCancel () {
      this.uuid = ''
      this.isVisible = false
      this.form.resetFields()
      // 重置编辑状态
      this.title = '新增公司'
      this.currentCompany = null
    }
  }
}
</script>

  <style scoped>

  </style>
